module.exports = __webpack_public_path__ + "img/donation-prep-10.06f365c0.png";